import React from "react";
import Header from "../Header/Header";
import TableHeader from "../TableContainer/TableHeader/TableHeader";
import TableInfo from "../TableContainer/Table/TableInfo";
import Table from "../TableContainer/Table/Table";
import Footer from "../Footer/Footer";
import { useMediaQuery } from "react-responsive";
import OutlinedCard from "../Card/mobCard";

function EodAnalytics() {
  const isDesktopOrLaptop = useMediaQuery({ query: "(min-width: 1024px)" });
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 768px)" });

  return (
    <>
      <div className="App">
        <div style={{ zIndex: 1000, position: "sticky", top: 0 }}>
          <Header />
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 0,
            // marginTop: '10px',
          }}
        >
          <TableHeader />
          <TableInfo />
          <Table />
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "flex-start",
            justifyContent: "flex-start",
            marginLeft: "128px",
          }}
        >
          <Footer />
        </div>
      </div>
    </>
  );
}

export default EodAnalytics;
